export const PLACE_ORDER= 'PLACE_ORDER'
export const PLACE_ORDER_SUCCESS= 'PLACE_ORDER_SUCCESS'
export const PLACE_ORDER_ERROR='PLACE_ORDER_ERROR'

export const PlaceOrder= (data, onComplete) => ({
    type: PLACE_ORDER,
    payload: data,
    onComplete : onComplete
});

